/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { Icon } from 'semantic-ui-react'
import { useTranslation } from 'react-i18next'

const DismissButton = ({onDismiss}) => {
    const [t] = useTranslation();

    return (
      <Icon
        onClick={onDismiss}
        css={css`
            position: absolute;
            top: 1px;
            right: 14px;
            z-index: 10;
            color: white;
            cursor: pointer;
        `}
        title={t('global.close')}
        name='delete'
        fitted
        color='white'
      />
    )
}

export { DismissButton }
